<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="row">
            <div class="col-md-6 rolelist">
                <div class="">
                    <h5 class=""></h5>
                </div>
            </div>

            <div class="col-md-6 rolelist" v-if="Auth.role == 1">
                <div class="addrole">
                    <router-link to="/admin/dashboard/addlead"><a class="">Add Lead</a></router-link>
                </div>
            </div>

            <div class="col-md-12 rolelistupper">
                <div class="card">
                    <h5 class="card-title">Lead List</h5>

                    <FlashMessage :position="'right top'"></FlashMessage>

                    <div class="card-body table-responsive table-full-width">

                        <table class="table table-borderd mt-5" id="myTable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Promotion</th>
                                    <th>Assign User</th>
                                    <th>Status</th>
                                    <th>FollowUp Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="data in tableData" v-bind:key="data.enquiryid">
                                    <td>{{data.enquiryid}}</td>
                                    <td>{{data.name}}</td>
                                    <td>{{data.promotion}}</td>
                                    <td>{{data.assignusername}}</td>
                                    <td>{{data.leadstatusname}}</td>
                                    <td>{{data.followdate}}</td>
                                    <td><button @click.prevent="deleteData(data.enquiryid)" class="btnborderremove">
                                            <a><b-icon-trash></b-icon-trash></a>
                                        </button>&nbsp; &nbsp; <router-link :to="'/admin/dashboard/editenquiry/' + data.enquiryid"><button class="btnborderremove">
                                            <a><b-icon-pencil-square></b-icon-pencil-square></a>
                                            </button></router-link>&nbsp; &nbsp; <router-link :to="'/admin/dashboard/editenquirynote/' + data.enquiryid"><button class="btnborderremove">
                                                <a><b-icon-eye></b-icon-eye></a>
                                            </button></router-link>
                                    </td>

                                </tr>
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

    
<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import datatable from "datatables.net-bs4"
import Auth from '../../../Auth.js';
import Vue from 'vue'
import $ from "jquery"
import {
    Table,
    TableColumn
} from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
export default {
    name: 'listLead',

    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            tableData: [],
            Auth: '',
        }
    },

    methods: {

        table() {
            this.$nextTick(() => {
                $('#myTable').DataTable();
            });
        },

        getData() {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/allenquiry`).then((res) => {
                this.tableData = res.data;
                this.table();
            });
        },

        deleteData(enquiryid) {
            this.axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/enquiry/delete/` + enquiryid).then((res) => {
                this.list = res;
                this.getData();
            });
        },

    },

    mounted() {
        this.getData();
        this.Auth = Auth.user;
    },

};
</script>

    
<style lang="scss">

    </style>
